import { useState } from "react";

import { Search, GradientButton } from "../../components/forms";
import { PageContainer } from "../../components/PageComponents";
import { ContentInfo, NewContentModal } from "./components";

const Content = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  return (
    <PageContainer title="Content Management">
      <div className="row-4">
        <Search
          placeholder="Search for content group..."
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <GradientButton
          content="New Content Group"
          onClick={() => setModalOpen(!modalOpen)}
        />
      </div>
      {modalOpen && (
        <NewContentModal close={() => setModalOpen(false)} content={info[0]} />
      )}
      <ContentInfo info={info} />
    </PageContainer>
  );
};

export default Content;

const info = [
  {
    id: 1,
    title: "Most Popular Today",
    content: [
      { id: 101, title: "PUBG Mobile UC", img: "/images/PUBG.jpeg" },
      { id: 102, title: "Fortnite", img: "/images/PUBG.jpeg" },
      { id: 103, title: "Steam", img: "/images/PUBG.jpeg" },
      { id: 104, title: "Call of duty Mobile", img: "/images/PUBG.jpeg" },
    ],
  },
  {
    id: 2,
    title: "Game Cards",
    content: [
      { id: 201, title: "PUBG Mobile UC", img: "/images/PUBG.jpeg" },
      { id: 202, title: "Fortnite", img: "/images/PUBG.jpeg" },
      { id: 203, title: "Steam", img: "/images/PUBG.jpeg" },
      { id: 204, title: "Call of duty Mobile", img: "/images/PUBG.jpeg" },
    ],
  },
  {
    id: 3,
    title: "Gift Cards",
    content: [
      { id: 301, title: "PUBG Mobile UC", img: "/images/PUBG.jpeg" },
      { id: 302, title: "Fortnite", img: "/images/PUBG.jpeg" },
      { id: 303, title: "Steam", img: "/images/PUBG.jpeg" },
      { id: 304, title: "Call of duty Mobile", img: "/images/PUBG.jpeg" },
    ],
  },
  {
    id: 4,
    title: "Electricity",
    content: [
      { id: 401, title: "PUBG Mobile UC", img: "/images/PUBG.jpeg" },
      { id: 402, title: "Fortnite", img: "/images/PUBG.jpeg" },
      { id: 403, title: "Steam", img: "/images/PUBG.jpeg" },
      { id: 404, title: "Call of duty Mobile", img: "/images/PUBG.jpeg" },
    ],
  },
];
